import React from 'react'
import "./TrainingCourses.css"
import { Col, Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

function TrainingCourses() {
  const { answerQuestion } = useSelector((state) => state);
  const { courses } = useSelector((state) => state);

  const navigate = useNavigate();

  return (
    <Container>
      <div className='training_courses my-5'>
        <h4 className='text-center'>الدروس الدرسية</h4>
        <p className='text-muted text-center'>
          يتكون البرنامج من {courses?.list.slice(0,5)?.length} دروس تغطي المهارات الأساسية للمواطنة الرقمية
        </p>
      </div>

      <Row>
        {courses?.list.slice(0,5).map((item, index) => {
          return (
            <Col md={6} key={index}>
              <div
                onClick={() => {
                  // 🔥 فتح الدرس مباشرة بدون أي شرط
                  navigate(`/course_details/${item?.id}`);
                }}
                className='mb-4 rounded'
              >
                <div className='mb-4 card_container rounded pb-4'>
                  <div style={{ height: "250px" }}>
                    <img 
                      src={item?.image} 
                      alt='' 
                      className='rounded mb-3 w-100 h-100'
                      style={{ objectFit: "contain" }}
                    />
                  </div>

                  <h5 className='text-black text-right px-4'>
                    {item?.sub_title}
                  </h5>

                  <p className='text-muted text-right px-4'>
                    {item?.paragraph}
                  </p>

                  <div className='see_more_btn'>عرض المزيد</div>
                </div>
              </div>
            </Col>
          )
        })}
      </Row>
    </Container>
  )
}

export default TrainingCourses
